import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { Text } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import theme from 'styles/theme';

const target = keyframes`
  from { background: inherit; }
  50% { background: ${theme.colors.blue}; }
  to { background: inherit; }
`;

const BaseDisclaimer = styled(Text)`
  :target {
    animation: ${target} 1s ease-out;
  }
`;

BaseDisclaimer.defaultProps = {
  as: 'p',
  m: 0,
  mb: 5,
  color: 'greys.steel',
  fontSize: 'xs',
};

BaseDisclaimer.displayName = 'BaseDisclaimer';

BaseDisclaimer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default BaseDisclaimer;
